import React, { useState } from "react";
import { useExistingBlocksData } from "../hooks/useExistingBlocksData";
import { Box, InputAdornment, MenuItem, Skeleton, TextField } from "@mui/material";
import { MagnifyingGlassIcon } from "shared/icons/MagnifyingGlassIcon";
import { KababMenu } from "shared/components/Menu/KababMenu";
import { AdjustmentIcon } from "shared/icons/AdjustmentIcon";
import { BlockLayoutTypes, BlockOptionLayouts } from "modules/MainSurveyEditor/helpers/blocks";
import { DraggableBlockOption } from "shared/components/BlockOption/DraggableBlockOption";
import { MainSurveyStore } from "modules/MainSurveyEditor/hooks/useMainSurvey";

export const ExistingBlocks = (props: ExistingBlocksProps) => {
  const {
    mainSurveyStore: { setExistingBlockToAdd },
  } = props;
  const [searchValue, setSearchValue] = useState<string>("");
  const [selectedFilter, setSelectedFilter] = useState<string[]>([]);
  const { existingBlocks, isLoading } = useExistingBlocksData(searchValue, selectedFilter);

  const filterOptions = [
    { name: "All types", blockType: undefined },
    ...(BlockOptionLayouts.find((layout) => layout.type === BlockLayoutTypes.Questions)?.options ?? []),
    ...(BlockOptionLayouts.find((layout) => layout.type === BlockLayoutTypes.Advanced)?.options ?? []),
  ];

  return (
    <div className="layout-existing-blocks">
      <div className="_d-flex-ali-center-sm-gap search-and-filter">
        <TextField
          placeholder="Search"
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          fullWidth
          variant="standard"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" sx={{ ml: 1 }}>
                <MagnifyingGlassIcon />
              </InputAdornment>
            ),
          }}
        />
        <KababMenu
          icon={<AdjustmentIcon />}
          closeOnClick
          items={filterOptions.map((option) => (
            <MenuItem
              key={option.blockType ?? "all"}
              onClick={() => setSelectedFilter(option.blockType ? [option.blockType] : [])}
              selected={option.blockType === selectedFilter[0]}
            >
              {option.name}
            </MenuItem>
          ))}
        />
      </div>
      <div className="existing-options-container">
        {isLoading ? (
          <Loader />
        ) : (
          existingBlocks.map((block) => (
            <DraggableBlockOption
              key={block.fieldId}
              onDragStart={() => setExistingBlockToAdd(block)}
              onDragEnd={() => setExistingBlockToAdd(null)}
              blockType={block.contentType}
              title={block.title}
              subtitle={block.fieldId}
              isTitlePrimary
            />
          ))
        )}
      </div>
    </div>
  );
};

const Loader = () => (
  <Box className="_d-grid" p={3}>
    <Skeleton />
    <Skeleton />
    <Skeleton />
  </Box>
);

interface ExistingBlocksProps {
  mainSurveyStore: MainSurveyStore;
}
